/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const navCategorySelectFlyoutStyle = {
  navCategorySelectFlyout: (theme: Theme) => ({
    display: "none",
    position: "absolute",
    top: "calc(100% + 1px)",
    left: 0,
    right: 0,
    width: "100%",
    justifyContent: "center",
    backgroundColor: theme.palette.background.default,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: "4px 12px 24px 0 rgba(89, 94, 95, 0.08)",
    [theme.breakpoints.up("lg")]: {
      paddingTop: "1rem",
      backgroundColor: "transparent",
      boxShadow: "none",
      borderBottom: "none",
    },
  }),
  active: {
    display: "flex",
  },
  links: (theme: Theme) => ({
    padding: "0.5rem",
    backgroundColor: "transparent",
    maxWidth: "100%",
    [theme.breakpoints.up("lg")]: {
      borderRadius: "0.5rem",
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.default,
      boxShadow: "4px 12px 24px 0 rgba(89, 94, 95, 0.08)",
    },
  }),
  link: (theme: Theme) => ({
    color: theme.palette.text.primary,
    padding: "0.75rem 0.5rem",
    display: "block",
    whiteSpace: "nowrap",
    borderRadius: "0.25rem",
    [theme.breakpoints.up("lg")]: {
      padding: "1.125rem 1rem",
    },
  }),
  linkActive: (theme: Theme) => ({
    backgroundColor: theme.palette.primaryPale,
  }),
};
